import type { CombatRatings } from "@/game/model/character-stats";
import { getGameSettings } from "@/game/model/game-settings";

export type HitResult =
  | { kind: "miss"; damage: 0; crit: false }
  | { kind: "hit"; damage: number; crit: boolean };

export function dodgeChance(attacker: CombatRatings, defender: CombatRatings): number {
  const s = getGameSettings();
  const raw = (defender.dodge / (defender.dodge + attacker.hit)) * s.combatDodgeScale;
  return Math.min(s.combatDodgeMax, Math.max(s.combatDodgeMin, raw));
}

export function mitigatedDamage(attacker: CombatRatings, defender: CombatRatings): number {
  const s = getGameSettings();
  const denom = defender.defense + s.combatDefenseK + attacker.level * 2;
  const factor = 1 - defender.defense / denom;
  const base = attacker.attack * factor;
  return Math.max(1, Math.floor(base));
}

export function resolveHit(
  attacker: CombatRatings,
  defender: CombatRatings,
  damageMultiplier = 1,
): HitResult {
  if (Math.random() < dodgeChance(attacker, defender)) {
    return { kind: "miss", damage: 0, crit: false };
  }
  let damage = mitigatedDamage(attacker, defender);
  const mult = Math.max(0.1, damageMultiplier);
  damage = Math.max(1, Math.floor(damage * mult));
  const crit = Math.random() < attacker.critChance;
  if (crit) {
    damage = Math.max(1, Math.floor(damage * attacker.critMultiplier));
  }
  return { kind: "hit", damage, crit };
}
